module.exports = __webpack_public_path__ + "static/media/logoBrandBlue.268866da.webp";